module.exports = __webpack_public_path__ + "img/download.63c18bf5.svg";